import { assets } from "@/lib/assets"
import WaveLines from "@/components/WaveLines"

function Story() {
  return (
    <section id="story" data-nav="light" className="relative overflow-hidden bg-[#88a8bc] text-white">
      <div className="grid min-h-[880px] lg:grid-cols-2">
        <div className="relative flex min-h-[540px] items-center px-8 py-24 md:px-16 sm:px-10">
          <WaveLines />
          <div className="relative mx-auto max-w-md text-center">
            <h2 className="font-serif-tc text-[32px] font-light leading-[1.7] tracking-[0.14em] md:text-[40px]">
              有些情緒，
              <br />
              值得被留下。
            </h2>
            <div className="mx-auto my-9 h-12 w-px bg-white/35" />
            <p className="text-[14px] font-light leading-8 tracking-[0.1em] text-white/85">
              一首歌結束，
              <br />
              情緒卻不會立刻消失。
              <br />
              我們把演出中的片刻，
              <br />
              轉化成一種可以被帶走的氣味。
            </p>
          </div>
        </div>

        <div className="relative min-h-[520px]">
          <img
            src={assets.concert}
            alt="現場演唱會"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#163044]/45 via-transparent to-transparent" />
        </div>
      </div>
    </section>
  )
}

export default Story
